import { AddSentenceCompletionComponent } from 'src/app/pages/resources/training-module/add-sentence-completion/add-sentence-completion.component';
import { AddSentenceCompletionBlankComponent } from 'src/app/pages/resources/training-module/add-sentence-completion-blank/add-sentence-completion-blank.component';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AddKeyVocabularyComponent } from 'src/app/pages/resources/key-vocabulary/add-key-vocabulary/add-key-vocabulary.component';
import { AddKeyVocabularyDefinitionComponent } from 'src/app/pages/resources/key-vocabulary/add-key-vocabulary-definition/add-key-vocabulary-definition.component';
import { AddPictureQuestionComponent } from 'src/app/pages/resources/picture-description/add-picture-question/add-picture-question.component';
import { AddSpeakerComponent } from 'src/app/pages/resources/conversation/add-speaker/add-speaker.component';
import { AddConversationComponent } from 'src/app/pages/resources/conversation/add-conversation/add-conversation.component';
import { AddWordPronunciationComponent } from 'src/app/pages/resources/word-pronunciation/add-word-pronunciation/add-word-pronunciation.component';
import { AddSentencePronunciationComponent } from 'src/app/pages/resources/sentence-pronunciation/add-sentence-pronunciation/add-sentence-pronunciation.component';
import { AddMatchingExerciseComponent } from 'src/app/pages/resources/matching-exercise/add-matching-exercise/add-matching-exercise.component';
import { AddWordGroupComponent } from 'src/app/pages/resources/word-class/add-word-group/add-word-group.component';
import { AddWordClassComponent } from 'src/app/pages/resources/word-class/add-word-class/add-word-class.component';
import { AddRewordingComponent } from 'src/app/pages/resources/rewording/add-rewording/add-rewording.component';
import { AddSenteceStructureComponent } from 'src/app/pages/resources/sentece-structure/add-sentece-structure/add-sentece-structure.component';
import { AddDictationComponent } from 'src/app/pages/resources/dictation/add-dictation/add-dictation.component';
import { AddMultipleChoiceComponent } from 'src/app/pages/resources/multiple-choice-question/add-multiple-choice/add-multiple-choice.component';
import { AddMultipleChoiceQuestionAnswerComponent } from 'src/app/pages/resources/multiple-choice-question/add-multiple-choice-question-answer/add-multiple-choice-question-answer.component';
import { AddTongueTwisterComponent } from 'src/app/pages/resources/tongue-twister/add-tongue-twister/add-tongue-twister.component';
import { AddProgramLevelComponent } from 'src/app/pages/resources/programs/add-program-level/add-program-level.component';
import { AddProgramLevelLessonComponent } from 'src/app/pages/resources/programs/add-program-level-lesson/add-program-level-lesson.component';
import { AddProgramLevelLessonModuleComponent } from 'src/app/pages/resources/programs/add-program-level-lesson-module/add-program-level-lesson-module.component';
import { AddPictureDescriptionExerciseComponent } from 'src/app/pages/resources/picture-description/add-picture-description-exercise/add-picture-description-exercise.component';
import { AddSenteceStructureExerciseComponent } from 'src/app/pages/resources/sentece-structure/add-sentece-structure-exercise/add-sentece-structure-exercise.component';
import { AddHangmanComponent } from 'src/app/pages/resources/hangman/add-hangman/add-hangman.component';
import { AddCommonMistakesComponent } from 'src/app/pages/resources/common-mistakes/add-common-mistakes/add-common-mistakes.component';
import { AddPlacementVocabularyQuestionComponent } from 'src/app/pages/testing-center/placement-test/add-placement-vocabulary-question/add-placement-vocabulary-question.component';
import { AddPlacementVocabularyQuizComponent } from 'src/app/pages/testing-center/placement-test/add-placement-vocabulary-quiz/add-placement-vocabulary-quiz.component';
import { AddPlacementGrammarComponent } from 'src/app/pages/testing-center/placement-test/add-placement-grammar/add-placement-grammar.component';
import { AddPlacementListeningComponent } from 'src/app/pages/testing-center/placement-test/add-placement-listening/add-placement-listening.component';
import { AddPlacementReadingComponent } from 'src/app/pages/testing-center/placement-test/add-placement-reading/add-placement-reading.component';
import { AddPlacementAnswerComponent } from 'src/app/pages/testing-center/placement-test/add-placement-answer/add-placement-answer.component';
import { NgsPlacementFormComponent } from 'src/app/pages/testing-center/ngs-placement-test/ngs-placement-form/ngs-placement-form.component';
import { AddMaterialBookClubComponent } from 'src/app/pages/book-club/add-material-book-club/add-material-book-club.component';
import { AddExerciseBookClubComponent } from 'src/app/pages/book-club/add-exercise-book-club/add-exercise-book-club.component';
import { AddAnswerExerciseBookClubComponent } from 'src/app/pages/book-club/add-answer-exercise-book-club/add-answer-exercise-book-club.component';
import { AddClassroomComponent } from 'src/app/pages/enrollment/classroom/add-classroom/add-classroom.component';
import { AddProgramReadingComponent } from 'src/app/pages/resources/programs/add-program-reading/add-program-reading.component';
import { AddRegisterTestResultComponent } from 'src/app/pages/enrollment/register-test/add-register-test-result/add-register-test-result.component';
import { AddMcqGeneralPlacementComponent } from 'src/app/pages/testing-center/ngs-placement-test/add-mcq-general-placement/add-mcq-general-placement.component';
import { AddReadingLevelComponent } from 'src/app/pages/reading-club/add-reading-level/add-reading-level.component';
import { AddReadingClubComponent } from 'src/app/pages/reading-club/add-reading-club/add-reading-club.component';
import { AddReadingTargetAgeComponent } from 'src/app/pages/reading-club/add-reading-target-age/add-reading-target-age.component';
import { AddReadingTypeComponent } from 'src/app/pages/reading-club/add-reading-type/add-reading-type.component';
import { AddReadingTextConvertorComponent } from 'src/app/pages/reading-club/add-reading-text-convertor/add-reading-text-convertor.component';
import { AddAppSlideComponent } from 'src/app/pages/app-center/add-app-slide/add-app-slide.component';
import { AddAppVideoComponent } from 'src/app/pages/app-center/add-app-video/add-app-video.component';
import { AddTrainingStudentComponent } from 'src/app/pages/training/add-training-student/add-training-student.component';
import { AddTrainingAdminssionComponent } from 'src/app/pages/training/add-training-adminssion/add-training-adminssion.component';
import { AddTrainingTutorComponent } from 'src/app/pages/training/add-training-tutor/add-training-tutor.component';
import { AddTrainingBatchComponent } from 'src/app/pages/training/add-training-batch/add-training-batch.component';
import { AddNewAndTrendingComponent } from 'src/app/pages/bookstore/add-new-and-trending/add-new-and-trending.component';
import { AddReadingUserComponent } from 'src/app/pages/reading-club/reading-user/add-reading-user/add-reading-user.component';
import { AddReadingBatchComponent } from 'src/app/pages/reading-club/reading-batch/add-reading-batch/add-reading-batch.component';
import { AddReadingBatchLevelComponent } from 'src/app/pages/reading-club/reading-batch-level/add-reading-batch-level/add-reading-batch-level.component';
import { AddBatchLevelStudentComponent } from 'src/app/pages/reading-club/reading-batch-level-student/add-batch-level-student/add-batch-level-student.component';
import { SchoolFormComponent } from 'src/app/pages/reading-club/schools/school-form/school-form.component';
import { AddAnswerRewordingComponent } from 'src/app/pages/resources/rewording/add-answer-rewording/add-answer-rewording.component';
import { AddYearComponent } from 'src/app/pages/reading-club/academic-year/add-year/add-year.component';
import { EditYearComponent } from 'src/app/pages/reading-club/academic-year/edit-year/edit-year.component';

export const ENTRY_COMPONENTS = [
  AddSentenceCompletionComponent,
  AddSentenceCompletionBlankComponent,
  DeleteComponent,
  AddKeyVocabularyComponent,
  AddKeyVocabularyDefinitionComponent,
  AddPictureQuestionComponent,
  AddSpeakerComponent,
  AddConversationComponent,
  AddWordPronunciationComponent,
  AddSentencePronunciationComponent,
  AddMatchingExerciseComponent,
  AddWordGroupComponent,
  AddWordClassComponent,
  AddRewordingComponent,
  AddSenteceStructureComponent,
  AddDictationComponent,
  AddMultipleChoiceComponent,
  AddMultipleChoiceQuestionAnswerComponent,
  AddTongueTwisterComponent,
  AddProgramLevelComponent,
  AddProgramLevelLessonComponent,
  AddProgramLevelLessonModuleComponent,
  AddPictureDescriptionExerciseComponent,
  AddSenteceStructureExerciseComponent,
  AddHangmanComponent,
  AddCommonMistakesComponent,
  AddPlacementVocabularyQuestionComponent,
  AddPlacementVocabularyQuizComponent,
  AddPlacementGrammarComponent,
  AddPlacementListeningComponent,
  AddPlacementReadingComponent,
  AddPlacementAnswerComponent,
  NgsPlacementFormComponent,
  AddMaterialBookClubComponent,
  AddExerciseBookClubComponent,
  AddAnswerExerciseBookClubComponent,
  AddClassroomComponent,
  AddProgramReadingComponent,
  AddRegisterTestResultComponent,
  AddMcqGeneralPlacementComponent,
  AddReadingLevelComponent,
  AddReadingClubComponent,
  AddReadingTargetAgeComponent,
  AddReadingTypeComponent,
  AddReadingTextConvertorComponent,
  AddAppSlideComponent,
  AddAppVideoComponent,
  AddTrainingStudentComponent,
  AddTrainingAdminssionComponent,
  AddTrainingTutorComponent,
  AddTrainingBatchComponent,
  AddNewAndTrendingComponent,
  AddReadingUserComponent,
  AddReadingBatchComponent,
  AddReadingBatchLevelComponent,
  AddBatchLevelStudentComponent,
  SchoolFormComponent,
  AddAnswerRewordingComponent,
  AddYearComponent,
  EditYearComponent
]
